import { render } from "./SliceVersionList.vue?vue&type=template&id=28308eea&scoped=true&ts=true"
import script from "./SliceVersionList.vue?vue&type=script&lang=ts"
export * from "./SliceVersionList.vue?vue&type=script&lang=ts"

import "./SliceVersionList.vue?vue&type=style&index=0&id=28308eea&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28308eea"]])

export default __exports__